import App from './App.svelte';

let i = `${Math.floor(Math.random() * 25) + 1}`;
if (i.length == 1) {
    i = "0" + i;
}
const app = new App({
	target: document.body,
    props: {
        vislogo: `./vislogos/small/vis${i}.png`
    }
});

export default app;